var _path, _rect, _path2, _rect2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadExcelBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 7.03125V67.9688H61.4375V22.5L60.7344 21.7969L46.6719 7.73437L45.9688 7.03125H14.5625ZM19.25 11.7188H42.6875V25.7812H56.75V63.2812H19.25V11.7188ZM47.375 15L53.4688 21.0938H47.375V15ZM26.2812 30.4688L35.1875 43.3594L26.2812 56.25H31.9062L38 47.3438L44.0938 56.25H49.7188L40.8125 43.3594L49.7188 30.4688H44.0938L38 39.375L31.9062 30.4688H26.2812Z",
    fill: "#0B63E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.0625,
    y: 42.1875,
    width: 14.0625,
    height: 28.125,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 63.3511L66.125 63.3511L66.1982 46.875L63.8545 46.875L61.5107 46.875L61.4141 63.3511L52.0625 63.3511L63.7813 75.0698L75.5 63.3511Z",
    fill: "#0B63E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6553,
    y: 59.8091,
    width: 4.61679,
    height: 14.1144,
    transform: "rotate(-45 41.6553 59.8091)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.375 60.9375L52.0625 60.9375L52.0625 65.625L47.375 60.9375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExcelBlue);
export default __webpack_public_path__ + "static/media/Download-Excel-Blue.e6eeda43c0918b8a61f1f1bf575b805c.svg";
export { ForwardRef as ReactComponent };